import { render, staticRenderFns } from "./CheckboxInline.vue?vue&type=template&id=3859365a&scoped=true"
import script from "./CheckboxInline.vue?vue&type=script&lang=js"
export * from "./CheckboxInline.vue?vue&type=script&lang=js"
import style0 from "./CheckboxInline.vue?vue&type=style&index=0&id=3859365a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3859365a",
  null
  
)

export default component.exports